import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../assets/Icon";

function MockInterviewCard({ moduleInfo }) {
  return (
    <Link
      to="/mock-interview"
      // onClick={handleNavigate}
      className="relative orange-card basis-[49%] flex flex-col gap-[0.3rem] rounded-xl shadow px-[1rem] xl:px-[1.45rem] py-[1.2rem] hover-effect cursor-pointer"
    >
      <div className="flex flex-col gap-1">
        <div className="border-[2px] py-[.45rem] px-[.5rem] border-[#DFDFDF] flex justify-center items-center w-fit rounded-[8px]">
          <Icon type="drawer-mock-interview-logo" color="#101828" />
        </div>

        <div className="text-[#101828] font-semibold text-[1rem]">
          Mock Interview
        </div>
      </div>
      <div className="text-[#475467] font-medium text-[0.875rem]">
        Practice with mock interviews featuring technical, behavioral, and
        situational questions.
      </div>
      <div className="lg:mt-8">
        <div className="lg:absolute block bottom-5 xl:left-6 left-4">
          {moduleInfo?.hasMockInterviewAccess ? (
            <span className="text-amber-600 w-fit font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-2 items-center">
              Start Interview Now <Icon type="right-arrow" color="#d97706" />
            </span>
          ) : (
            <span className="text-amber-600 w-fit font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-2 items-center">
              Request Access <Icon type="right-arrow" color="#d97706" />
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}

export default MockInterviewCard;
